import React, { useState, useEffect } from "react";

const DiscountCalculatorTwo = ({ setTotalFinalTwo, tasaDescuento }) => {
  const [montos, setMontos] = useState({
    dcc: 0,
    telcelMovistar: 0,
  });

  const formatNumber = (num) => {
    return `$${Math.round(num).toLocaleString("es-MX")}`;
  };

  useEffect(() => {
    if (!tasaDescuento) return;

    const mitad = tasaDescuento / 2;
    const bonificacionDCC = mitad * 0.25;
    const bonificacionATT = mitad * 0.30;

    const totalFinal = bonificacionDCC + bonificacionATT;

    setMontos({
      dcc: Math.round(bonificacionDCC / 0.01),
      telcelMovistar: Math.round(bonificacionATT / 0.03),
    });

    setTotalFinalTwo(totalFinal);
  }, [tasaDescuento, setTotalFinalTwo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const valorNumerico = value.replace(/\D/g, ""); // Solo números
    setMontos((prevMontos) => ({
      ...prevMontos,
      [name]: valorNumerico ? parseInt(valorNumerico, 10) : 0, // Guardar como número
    }));
  };

  return (
    <>
      <h1 className="mx-auto text-center text-6xl pt-32 pb-24 text-[#EC0000] 2xl:text-5xl 2xl:max-w-5xl xs:text-3xl">
        Ingresa los montos a cobrar y calcula la bonificación por servicio.
      </h1>
      <div className="bg-[#EC0000] p-6 rounded-lg mx-auto min-h-[550px] flex flex-col justify-center">
        <div className="grid grid-cols-4 md:grid-cols-1 items-center text-center h-full text-white">
          <div className="p-6 font-bold text-4xl leading-normal border-r border-white flex items-center justify-center h-full 2xl:text-3xl md:border-0">
            Calcula tu bonificación
          </div>

          <div className="p-6 border-r border-white flex flex-col justify-center md:border-0 h-full">
            <h3 className="font-bold text-4xl border-b border-white pb-2 text-center 2xl:text-3xl h-14">Servicio</h3>
            <p className="mt-4 text-xl text-left ml-4 h-14 flex items-center">Pago con moneda extranjera (DCC)</p>
            <p className="mt-4 text-xl text-left ml-4 h-14 flex items-center">Tiempo Aire Telcel, Movistar o AT&T</p>
          </div>

          <div className="p-6 border-r border-white flex flex-col justify-center md:border-0 h-full">
            <h3 className="font-bold text-4xl text-center 2xl:text-3xl">Monto</h3>

            <input
              type="text"
              name="dcc"
              className="block w-3/4 mx-auto mt-10 text-center border rounded-md p-2 text-white bg-[#EC0000] h-14 text-xl"
              value={formatNumber(montos.dcc)}
              onChange={handleChange}
            />

            <input
              type="text"
              name="telcelMovistar"
              className="block w-3/4 mx-auto mt-10 text-center border rounded-md p-2 text-white bg-[#EC0000] h-14 text-xl"
              value={formatNumber(montos.telcelMovistar)}
              onChange={handleChange}
            />
          </div>

          <div className="p-6 flex flex-col justify-center h-full">
            <h3 className="font-bold text-4xl border-b border-white pb-2 text-center 2xl:text-3xl h-14">Bonificación</h3>
            <p className="block w-3/4 mx-auto mt-6 text-center border rounded-md p-3 h-14 items-center justify-center text-xl bg-white text-black">
              {formatNumber(montos.dcc * 0.01)}
            </p>
            <p className="block w-3/4 mx-auto mt-3 text-center border rounded-md p-3 h-14 items-center justify-center text-xl bg-white text-black">
              {formatNumber(montos.telcelMovistar * 0.03)}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiscountCalculatorTwo;
